import moment from 'moment';

export const groupBy = (objectArray, property) => {
  return objectArray.reduce(function (acc, obj) {
    const key = obj[property];
    if (!acc[key]) {
      acc[key] = [];
    }
    for (let i = 0; i < obj.quantity; i++) {
      acc[key].push(obj);
    }
    return acc;
  }, {});
};

export const groupByTwoProperty = (objectArray, property_1, property_2) => {
  return objectArray.reduce(function (acc, obj) {
    const key = `${obj[property_2]}_${obj[property_1]}`;
    if (!acc[key]) {
      acc[key] = [];
    }

    for (let i = 0; i < obj.quantity; i++) {
      acc[key].push(obj);
    }
    return acc;
  }, {});
};

export const groupByPostingNumber = (objectArray, property) => {
  return objectArray.reduce(function (acc, obj) {
    const key = obj[property];
    if (!acc[key]) {
      acc[key] = [];
    }

    acc[key].push(obj);

    return acc;
  }, {});
};
export const groupByPostingNumberShop = (objectArray, property_1, property_2) => {
  return objectArray.reduce(function (acc, obj) {
    const key = `${obj[property_2]}_${obj[property_1]}`;
    if (!acc[key]) {
      acc[key] = [];
    }

    acc[key].push(obj);

    return acc;
  }, {});
};

export const numberWithSpaces = (number = '') => (number || 0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

export const formDate = (item) => (item.toString().length === 1 ? '0'.concat(item) : item);

export const getDay = (d) => {
  return new Date(d).getDate();
};

export const getDateMonth = (dat) => {
  if (!dat) {
    return '';
  }
  const date = new Date(dat);
  const day = date.getDate();
  const month = date.getMonth() + 1;
  return `${formDate(day)}.${formDate(month)}`;
};

export const getDateSolid = (date) => {
  return new Date(moment(date).add(new Date().getTimezoneOffset() / 60, 'h'))
}

export const setDateSolid = (date) => {
  return new Date(moment(date).startOf('day').utc(true))
}

export const getDate = (dat) => {
  if (!dat) {
    return '';
  }
  const date = new Date(dat);
  const day = date.getDate();
  const month = date.getMonth() + 1;
  const year = date.getFullYear();
  return `${formDate(day)}.${formDate(month)}.${year}`;
};

export const getTime = (dat) => {
  const date = new Date(dat);
  const hours = date.getHours();
  const minutes = date.getMinutes();
  return `${formDate(hours)}:${formDate(minutes)}`;
};
export const getTimeWithSeconds = (dat) => {
  const date = new Date(dat);
  const hours = date.getHours();
  const minutes = date.getMinutes();
  const seconds = date.getSeconds();

  return `${formDate(hours)}:${formDate(minutes)}:${formDate(seconds)}`;
};

export const formFullDate = (date) => {
  if (!date) {
    return '';
  }
  const d = new Date(date);
  const day = d.getDate();
  const month = d.getMonth() + 1;
  const year = d.getFullYear();

  return `${formDate(day)}.${formDate(month)}.${year} ${getTime(date)}`;
};

export const formFullDateWithSeconds = (date) => {
  if (!date) {
    return '-';
  }
  const d = new Date(date);
  const day = d.getDate();
  const month = d.getMonth() + 1;
  const year = d.getFullYear();

  return `${formDate(day)}.${formDate(month)}.${year} ${getTimeWithSeconds(date)}`;
};



export const calcDaysAfterUpdate = (start) => {
  const date1 = moment(start);
  const date2 = moment();
  const diff = date2.diff(date1, 'days');

  return diff;
};

export const sortByDate = (arr, key = 'date') => {
  let new_arr = arr;
  new_arr.sort((a, b) => {
    return a[key] - b[key] > 0 ? 1 : -1;
  });
  return [...new_arr];
};

const time_parts = {
  year: { name: 'year', div: 31536000000, mod: 10000 },
  day: { name: 'day', div: 86400000, mod: 365 },
  hours: { name: 'hour', div: 3600000, mod: 24 },
  minute: { name: 'minute', div: 60000, mod: 60 },
  second: { name: 'second', div: 1000, mod: 60 },
};

export const getDifferenceTime = (end, start = new Date()) => {
  const interval = new Date(end).getTime() - new Date(start).getTime();
  let seconds = Math.floor(interval / time_parts.second.div);

  if (seconds <= 0) {
    return 0;
  }

  //const days = Math.floor(interval / time_parts.day.div);
  const hours = Math.floor(interval / time_parts.hours.div) % time_parts.hours.mod;
  const minutes = Math.floor(interval / time_parts.minute.div) % time_parts.minute.mod;
  seconds %= time_parts.second.mod;

  return `${hours}ч. ${minutes}м. ${seconds}c.`;
};

export const formDataFromOrder = (str = '') => {
  if (str.length > 8) {
    const trim = str.slice(0, 8);
    return `${trim.slice(3, 5)}.${trim.slice(0, 2)}.2020`;
  }
  return '';
};

export const getProvider = (item = {}, providers = []) => {
  let provider;
  if (item.provider || item.provider === 0) {
    const p = providers.find((p) => item.provider === p.id);
    if (p) {
      provider = p;
    }
  }

  return provider;
};

export const getProviderNew = (providerId, providers = []) => {
  let provider;
  if (providerId) {
    const p = providers.find((p) => providerId === p.id);
    if (p) {
      provider = p;
    }
  }
  return provider;
};

export const getMethod = (method = '', methods = []) => {
  let res;

  const p = methods.find((p) => p.method === method);
  if (p) {
    res = p;
  }

  return res;
};

export const divideToSubarray = (array, size = 2000) => {
  const subarray = [];
  for (let i = 0; i < Math.ceil(array.length / size); i++) {
    subarray[i] = array.slice(i * size, i * size + size);
  }

  return subarray;
};

export const checkNumber = (value) => (parseInt(value, 10) ? parseInt(value, 10) : 0);

export const valueText = (v, n) =>
  `${parseFloat(checkNumber(v))} x ${numberWithSpaces(n)} = ${numberWithSpaces(checkNumber(v) * n)}`;

const reg = new RegExp(`^[0-9]*$`);

export const validNumber = (value) => {
  return reg.test(value);
};

export const getKvantWb = (price, unit = 'шт.') => {
  const MAP_WORDS_WB = {
    'шт.': ['шт.', 'шт.', 'шт.'],
    'уп.': ['уп.', 'уп.', 'уп.'],
    набор: ['набор', 'набора', 'наборов'],
    пакет: ['уп.', 'уп.', 'уп.'],
  };

  let unit_ = MAP_WORDS_WB[unit || 'шт.'] || MAP_WORDS_WB['шт.'];
  if (price > 200) {
    return '';
  }
  if (price < 200 && price > 30) {
    return `, n ${unit_[2]}`;
  }
  if (price < 30) {
    return `, nn ${unit_[2]}`;
  }
  return '';
};

const MAP_WORDS_WB = {
  'шт.': ['шт.', 'шт.', 'шт.'],
  'уп.': ['уп.', 'уп.', 'уп.'],
  набор: ['набор', 'набора', 'наборов'],
  пакет: ['уп.', 'уп.', 'уп.'],
  пара: ['пара', 'пары', 'пар'],
};

const MAP_WORDS = {
  'шт.': ['штука', 'штуки', 'штук'],
  'уп.': ['упаковка', 'упаковки', 'упаковок'],
  набор: ['набор', 'набора', 'наборов'],
  пакет: ['пакетик', 'пакетика', 'пакетиков'],
  пара: ['пара', 'пары', 'пар'],
};

const getNumWord = (value, unit = 'шт.', is_wb = false) => {
  let words = is_wb ? MAP_WORDS_WB[unit] || ['шт.', 'шт.', 'шт.'] : MAP_WORDS[unit] || ['', 'шт.'];
  value = Math.abs(value) % 100;
  const num = value % 10;
  words = words?.length > 2 ? words : ['шт.', 'шт.', 'шт.'];
  if (value > 10 && value < 20) return words[2];
  if (num > 1 && num < 5) return words[1];
  if (num == 1) return words[0];
  return words[2];
};

export const getProviderIdAndArtnumberBySku = (skus, byId) => {
  return skus.map((sku) => ({ provider_id: byId[sku].provider_id, artnumber: byId[sku].artnumber }));
};

export const formNumQuantity = (kvant = 1, unit = 'шт.', is_wb = true, isRequiredNum = false) => {
  return `${kvant > 1 || isRequiredNum ? `, ${kvant} ${getNumWord(kvant, unit, is_wb)}` : ''}`;
};

export const checkProviderInProduct = (product) => product.providerId || product.providerId === 0;

export const calcNds = (price, nds) => (((price / (1 + nds / 100)) * nds) / 100).toFixed(2);
